import React from "react";
import PropTypes from "prop-types";
import CurrencyCell from "./cells/CurrencyCell";

const PledgeRowDisplay = ({
  pledgeId,
  pledgeDate,
  pledgeAmount,
  amountPaid,
  outstandingAmount,
  payOutSchedule,
  onEdit,
  disableEdit
}) => (
  <tr>
    <td className="text-right">{pledgeId}</td>
    <td className="text-right">{pledgeDate}</td>
    <CurrencyCell value={pledgeAmount} />
    <CurrencyCell value={amountPaid || 0} />
    <CurrencyCell value={outstandingAmount} />
    <td className="text-left">{payOutSchedule || "-"}</td>
    <td className="text-center">
      <i
        className={`icon-pencil primary-hover input ${disableEdit ? "disabled" : ""}`}
        onClick={!disableEdit ? onEdit : null}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if ((e.key === "Enter" || e.key === " ") && !disableEdit) onEdit();
        }}
        aria-label="Edit pledge"
      />
    </td>
  </tr>
);

PledgeRowDisplay.propTypes = {
  pledgeId: PropTypes.string.isRequired,
  pledgeDate: PropTypes.string.isRequired,
  pledgeAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  amountPaid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  outstandingAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  payOutSchedule: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  disableEdit: PropTypes.bool
};

PledgeRowDisplay.defaultProps = {
  payOutSchedule: "",
  disableEdit: false
};

export default PledgeRowDisplay;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/PledgeRowDisplay.jsx